import FontFaceObserver from "fontfaceobserver";
import analytics from "web/script/analytics/analytics";
import cookie from "web/script/utils/cookie";

const FONT_LOAD_TIMEOUT = 5000; // 5s
const FONT_TEST_CHARS = "BESbswy"; // TODO: i18n?
const FONT_CLASSNAME = "fonts-pending";
const LYST_FONTS = [
    [
        "Brown",
        {
            weight: "normal",
            style: "normal",
        },
    ],
    [
        "Brown",
        {
            weight: "bold",
            style: "normal",
        },
    ],
    [
        "IBM Plex Sans",
        {
            weight: "normal",
            style: "normal",
        },
    ],
    [
        "IBM Plex Sans",
        {
            weight: 300,
            style: "normal",
        },
    ],
];

function namify(name, args) {
    if (args.weight == "bold") {
        name += " Bold";
    } else if (args.weight == 300) {
        name += " Light";
    }
    if (args.style == "italic") {
        name += " Italic";
    }
}

async function createObserver(name, args) {
    let observer = new FontFaceObserver(name, args);
    try {
        return await observer.load(FONT_TEST_CHARS, FONT_LOAD_TIMEOUT);
    } catch (e) {
        // TODO: This causes failed font loads to appear to be successful ones.
        //       I don't think this is what we want
        let fancyName = namify(name, args);
        console.error("Custom font", fancyName, "did not load within 5 seconds.");
        analytics.event("fonts", "failed", fancyName, true);
    }
}

async function loadFonts() {
    let documentClasses = document.documentElement.classList;
    // Check to see if the magic cookie is set and we can let fonts load normally
    if (!documentClasses.contains(FONT_CLASSNAME)) {
        return;
    }

    let observers = LYST_FONTS.map((args) => createObserver(...args));

    await Promise.all(observers);

    // The user has "successfully" loaded all fonts, let's avoid giving them the
    // fallback next time
    cookie("withfonts", "1", { path: "/" });
    documentClasses.remove(FONT_CLASSNAME);
}

export default loadFonts;
